import React from 'react';
import SectionsList from '../../../features/sections/SectionsList';

const CartPageSections = () => {
    return <SectionsList sectionLocation='cart' />;
};

export default CartPageSections;